import { render, staticRenderFns } from "./added-service.vue?vue&type=template&id=2118c268&"
import script from "./added-service.vue?vue&type=script&lang=js&"
export * from "./added-service.vue?vue&type=script&lang=js&"
import style0 from "./added-service.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports